export default "__VITE_ASSET__DoF_4nyJ__"